import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function advancedQuery(data) {
  return request({
    url: URL.booking.airExport.advancedQuery,
    method: 'post',
    data
  })
}

export function queryLastModifyBookingByDay(data) {
  return request({
    url: URL.booking.airExport.queryLastModifyBookingByDay,
    method: 'post',
    data
  })
}

// 通过keys获取空运出口job列表
export function getAirExportJobListByKeys(params) {
  return request({
    url: URL.booking.airExport.getListByKeys,
    method: 'get',
    params
  })
}

export function getAirExportJobByUuid(uuid) {
  return request({
    url: URL.booking.airExport.getAirExportJobByUuid,
    method: 'get',
    params: { uuid }
  })
}

export function updatePriceLockFunc(data) {
  return request({
    url: URL.booking.airExport.updatePriceLockUrl,
    method: 'post',
    data
  })
}

export function updateBatchPriceLockFunc(data) {
  return request({
    url: URL.booking.airExport.updateBatchPriceLockUrl,
    method: 'post',
    data
  })
}

export function saveAeBookingSpace(data, fullError, forbidAlert) {
  return request({
    url: URL.booking.airExport.save,
    method: 'post',
    fullError,
    forbidAlert,
    data
  })
}

export function changeOperateType(data) {
  return request({
    url: URL.booking.airExport.changeOperateType,
    method: 'post',
    data
  })
}

export function checkJobHAWBFiledExist(data) {
  return request({
    url: URL.booking.airExport.checkJobHAWBFiledExist,
    method: 'post',
    data
  })
}

export function validateMBL(data) {
  return request({
    url: URL.booking.airExport.validateMBL,
    method: 'post',
    data
  })
}

export function doCopyJob(data) {
  return request({
    url: URL.booking.airExport.doCopyJob,
    method: 'post',
    data
  })
}

export function importOrderJob(data) {
  return request({
    url: URL.booking.airExport.importOrderJob,
    method: 'post',
    data
  })
}

export function findAirExportJobByNo(data) {
  return request({
    url: URL.booking.airExport.findAirExportJobByNo,
    method: 'post',
    data
  })
}

export function selectMawb(data) {
  return request({
    url: URL.booking.airExport.selectMawb,
    method: 'get',
    params: data
  })
}

export function newConsole(data) {
  return request({
    url: URL.booking.airExport.newConsole,
    method: 'get',
    params: data
  })
}

export function attach(data) {
  return request({
    url: URL.booking.airExport.attach,
    method: 'get',
    params: data
  })
}

export function detch(data) {
  return request({
    url: URL.booking.airExport.detch,
    method: 'get',
    params: data
  })
}

export function sendSiteOp(data) {
  return request({
    url: URL.booking.airExport.sendSiteOp,
    method: 'post',
    data
  })
}

export function sendXCOpEmail(data) {
  return request({
    url: URL.booking.airExport.sendXCOpEmail,
    method: 'post',
    data
  })
}

export function changeMAWBNo(data) {
  return request({
    url: URL.booking.airExport.changeMAWBNo,
    method: 'post',
    data
  })
}

export function manualGenerateWarehouseNo(data) {
  return request({
    url: URL.booking.airExport.manualGenerateWarehouseNo,
    method: 'post',
    data
  })
}

export function batchCloneLcLJob(params) {
  return request({
    url: URL.booking.airExport.batchCloneLcLJob,
    method: 'get',
    params
  })
}

export function unbindingNew(data) {
  return request({
    url: URL.booking.airExport.unbindingNew,
    method: 'post',
    data
  })
}

export function complexQueryAeJobs(data) {
  return request({
    url: URL.booking.airExport.complexQueryAeJobs,
    method: 'post',
    data
  })
}

export function saveEntrustedByBranch(data) {
  return request({
    url: URL.booking.airExport.saveEntrustedByBranch,
    method: 'post',
    data
  })
}

export function saveCopyJob(data) {
  return request({
    url: URL.booking.airExport.saveCopyJob,
    method: 'post',
    data
  })
}

export function aeSaveCopyJob(data) {
  return request({
    url: URL.booking.airExport.saveCopyJob,
    method: 'post',
    data
  })
}

export function updateMasterMAWBOtherCharge(data) {
  return request({
    url: URL.booking.airExport.updateMasterMAWBOtherCharge,
    method: 'post',
    data
  })
}

export function batchAddJob(data, lclMasterUuid, location) {
  return request({
    url: URL.booking.airExport.batchAddJob,
    method: 'post',
    data,
    params: { lclMasterUuid, location }
  })
}

export function acceptJob(data) {
  return request({
    url: URL.booking.airExport.acceptJob,
    method: 'post',
    data
  })
}

export function preVerifyReject(data) {
  return request({
    url: URL.booking.airExport.preVerifyReject,
    method: 'get',
    params: data
  })
}

export function batchPreVerifyReject(params) {
  return request({
    url: URL.booking.airExport.batchPreVerifyReject,
    method: 'post',
    data: params
  })
}

export function needConfirmDepartment(data) {
  return request({
    url: URL.sys.needConfirmDepartment,
    method: 'get',
    params: data
  })
}

// 批量更新
export function batchUpdate(data, params) {
  return request({
    url: URL.booking.airExport.batchUpdate,
    method: 'put',
    data,
    params
  })
}

// 制单列表高级查询
export function documentMoreQuery(data) {
  return request({
    url: URL.booking.airExport.documentMoreQuery,
    method: 'post',
    data
  })
}

// 根据主单号查询job
export function getJobByMBL(params) {
  return request({
    url: URL.booking.airExport.getJobByMBL,
    method: 'get',
    params
  })
}

// 提交
export function submitState(params) {
  return request({
    url: URL.booking.airExport.submitState,
    method: 'get',
    params
  })
}

export function queryJobForMblFunc(data) {
  return request({
    url: URL.booking.airExport.queryJobForMblUrl,
    method: 'post',
    data
  })
}

export function saveDeliveryOperation(data) {
  return request({
    url: URL.booking.airExport.saveDeliveryOperationUrl,
    method: 'post',
    data
  })
}
export function takePhotosFunc(data) {
  return request({
    url: URL.booking.airExport.takePhotosUrl,
    method: 'post',
    data
  })
}

export function saveWeighingProcessingFunc(data) {
  return request({
    url: URL.booking.airExport.saveWeighingProcessingUrl,
    method: 'post',
    data
  })
}
// 航线订舱暂存
export function routeBookingStagingFunc(data) {
  return request({
    url: URL.booking.airExport.routeBookingStagingUrl,
    method: 'post',
    data
  })
}
// 航线订舱部分字段修改
export function updateRouteBookingFunc(data) {
  return request({
    url: URL.booking.airExport.updateRouteBookingUrl,
    method: 'post',
    data
  })
}
// 检查航线订舱尺寸
export function routeBookingCheckMeasurementsFunc(data) {
  return request({
    url: URL.booking.airExport.routeBookingCheckMeasurementsUrl,
    method: 'post',
    data
  })
}
// 航线订舱详情
export function routeBookingDetailFunc(data) {
  return request({
    url: URL.booking.airExport.routeBookingDetailUrl,
    method: 'post',
    data
  })
}
// 航线订舱确认回写业务
export function callBackJobFunc(data) {
  return request({
    url: URL.booking.airExport.callBackJobUrl,
    method: 'post',
    data
  })
}
// 航线产品收益统计
export function routeProductRevenueStatisticsFunc(data) {
  return request({
    url: URL.booking.airExport.routeProductRevenueStatisticsUrl,
    method: 'post',
    data
  })
}

// 投保
export function toInsure(data) {
  return request({
    url: URL.booking.airExport.toInsure,
    method: 'post',
    data
  })
}

// 复核通过
export function reviewThrough(data) {
  return request({
    url: URL.booking.airExport.reviewThrough,
    method: 'post',
    data
  })
}

// 复核拒绝
export function reviewRefusal(data) {
  return request({
    url: URL.booking.airExport.reviewRefusal,
    method: 'post',
    data
  })
}

// 出口转进口
export function createImportByExportJob(data) {
  return request({
    url: URL.booking.airExport.createImportByExportJob,
    method: 'post',
    data
  })
}

// 更新实际件毛体计费重量
export function updateQWCActual(data) {
  return request({
    url: URL.booking.airExport.updateQWCActual,
    method: 'put',
    data
  })
}

// 批量更新清关状态
export function batchUpdateDeclareCustomsState(data) {
  return request({
    url: URL.booking.airExport.batchUpdateDeclareCustomsState,
    method: 'post',
    data: data
  })
}

// 根据job拼箱主票和查询条件查询 隐含条件：未拼票的job
export function getAirExportJobsByLclMasterJob(data) {
  return request({
    url: URL.booking.airExport.getAirExportJobsByLclMasterJob,
    method: 'post',
    data: data
  })
}

// 根据业务编号查询关联进口业务
export function getRelatedAiJob(jobNo) {
  return request({
    url: URL.booking.airExport.getRelatedAiJob,
    method: 'get',
    params: { jobNo }
  })
}

// 根据业务编号查询业务
export function getTrustFromJob(jobNo) {
  return request({
    url: URL.booking.airExport.getTrustFromJob,
    method: 'get',
    params: { jobNo }
  })
}
// 交差委托空运出口同步
export function syncRelatedJobFunc(data) {
  return request({
    url: URL.booking.airExport.syncRelatedJobUrl,
    method: 'post',
    data
  })
}

// 空运订舱出口转进口，二次同步信息
export function syncRelatedJob(data) {
  return request({
    url: URL.booking.airExport.syncRelatedJob,
    method: 'post',
    data
  })
}

// 空运订舱出口批量修改业务
export function batchUpdateAeJob(data) {
  return request({
    url: URL.booking.airExport.batchUpdateAeJob,
    method: 'post',
    data
  })
}

export function getTemperatureRequirement() {
  return request({
    url: URL.mdm.basicData.temperatureRequirementAll,
    method: 'get'
  })
}

// 空运订舱出口批量修改业务-仓储信息
export function batchUpdateAeJobWarehouse(data) {
  return request({
    url: URL.booking.airExport.batchUpdateAeJobWarehouse,
    method: 'post',
    data
  })
}
// 空运订舱出口批量修改业务-航空公司
export function batchUpdateAeJobCarrierId(data) {
  return request({
    url: URL.booking.airExport.batchUpdateAeJobCarrierId,
    method: 'post',
    data
  })
}
